import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/menu-ios.jpg'
import _imports_1 from '../../../assets/install-ios-ru.jpg'
import _imports_2 from '../../../assets/confirm-ios-ru.jpg'
import _imports_3 from '../../../assets/menu-ios-en.jpg'
import _imports_4 from '../../../assets/install-ios-en.jpg'
import _imports_5 from '../../../assets/confirm-ios-en.jpg'
import _imports_6 from '../../../assets/menu-android.jpg'
import _imports_7 from '../../../assets/install-ru.jpg'
import _imports_8 from '../../../assets/confirm-ru.jpg'
import _imports_9 from '../../../assets/install-en.jpg'
import _imports_10 from '../../../assets/confirm-en.jpg'


const _hoisted_1 = { class: "stage" }
const _hoisted_2 = { class: "stage-inner" }
const _hoisted_3 = { class: "lead" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = {
  key: 0,
  class: "faq-photos"
}
const _hoisted_6 = {
  key: 1,
  class: "faq-photos"
}
const _hoisted_7 = { class: "card" }
const _hoisted_8 = {
  key: 0,
  class: "faq-photos"
}
const _hoisted_9 = {
  key: 1,
  class: "faq-photos"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"blobs\" aria-hidden=\"true\" data-v-3e397987><span class=\"blob b1\" data-v-3e397987></span><span class=\"blob b2\" data-v-3e397987></span><span class=\"blob b3\" data-v-3e397987></span><span class=\"blob b4\" data-v-3e397987></span></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "kicker" }, "Rainbow Manager", -1)),
      _createElementVNode("h1", null, _toDisplayString(_ctx.t('FAQ')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('faqLead')), 1),
      _createElementVNode("article", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.t('howInstallIOSTitle')), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.t('openAppInBrowserTitle')) + " ", 1),
          _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Safari", -1)),
          _createTextVNode(". " + _toDisplayString(_ctx.t('pressBtnTitle')) + " ", 1),
          _cache[1] || (_cache[1] = _createElementVNode("em", null, "Share", -1)),
          _createTextVNode(" (" + _toDisplayString(_ctx.t('squareIconTitle')) + "). " + _toDisplayString(_ctx.t('selectItem')) + " ", 1),
          _createElementVNode("em", null, _toDisplayString(_ctx.t('addToHomeScreenTitle')), 1),
          _createTextVNode(". " + _toDisplayString(_ctx.t('confirmAndClickTitle')) + " ", 1),
          _createElementVNode("em", null, _toDisplayString(_ctx.t('addTitle')), 1),
          _createTextVNode(". " + _toDisplayString(_ctx.t('appWillAppearText')), 1)
        ]),
        (_ctx.language === 'ru')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "1"),
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                })
              ], -1),
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "2"),
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: ""
                })
              ], -1),
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "3"),
                _createElementVNode("img", {
                  src: _imports_2,
                  alt: ""
                })
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.language === 'en')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "1"),
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: ""
                })
              ], -1),
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "2"),
                _createElementVNode("img", {
                  src: _imports_4,
                  alt: ""
                })
              ], -1),
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "3"),
                _createElementVNode("img", {
                  src: _imports_5,
                  alt: ""
                })
              ], -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("article", _hoisted_7, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.t('howInstallAndroidTitle')), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.t('openAppInBrowserTitle')) + " ", 1),
          _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Chrome", -1)),
          _createTextVNode(". " + _toDisplayString(_ctx.t('pressBtnTitle')) + " ", 1),
          _cache[5] || (_cache[5] = _createElementVNode("em", null, "⋮", -1)),
          _createTextVNode(" (" + _toDisplayString(_ctx.t('threeDotsText')) + "). " + _toDisplayString(_ctx.t('selectItem')) + " ", 1),
          _createElementVNode("em", null, _toDisplayString(_ctx.t('addToHomeScreenTitle')), 1),
          _createTextVNode(". " + _toDisplayString(_ctx.t('confirmAndClickTitle')) + " ", 1),
          _createElementVNode("em", null, _toDisplayString(_ctx.t('addTitle')), 1),
          _createTextVNode(". " + _toDisplayString(_ctx.t('appWillAppearText')), 1)
        ]),
        (_ctx.language === 'ru')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "1"),
                _createElementVNode("img", {
                  src: _imports_6,
                  alt: ""
                })
              ], -1),
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "2"),
                _createElementVNode("img", {
                  src: _imports_7,
                  alt: ""
                })
              ], -1),
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "3"),
                _createElementVNode("img", {
                  src: _imports_8,
                  alt: ""
                })
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.language === 'en')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "1"),
                _createElementVNode("img", {
                  src: _imports_6,
                  alt: ""
                })
              ], -1),
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "2"),
                _createElementVNode("img", {
                  src: _imports_9,
                  alt: ""
                })
              ], -1),
              _createElementVNode("figure", null, [
                _createElementVNode("span", null, "3"),
                _createElementVNode("img", {
                  src: _imports_10,
                  alt: ""
                })
              ], -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}